import { combineReducers } from 'redux';

import byPage from './byPage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('forumThreadsQueryString', combineReducers({ byPage }));



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/forumThreads/byQuery/reducer.js
 **/